module.exports = __webpack_public_path__ + "static/media/legato_logo.4ba886ba.png";